export const ANALYTICS_CATEGORIES = {
  PUBLIC_NAV: "PUBLIC_NAV",
  AUTH_NAV: "AUTH_NAV",
  LOOKUP_INTENT: "LOOKUP_INTENT",
  FEATURE_USAGE: "FEATURE_USAGE",
  CTA_ENGAGEMENT: "CTA_ENGAGEMENT",
  OUTBOUND_LINK: "OUTBOUND_LINK",
  SOCIAL_ENGAGEMENT: "SOCIAL_ENGAGEMENT",
  THEME_PREFERENCE: "THEME_PREFERENCE",
  UTILITY: "UTILITY",
  API_USAGE: "API_USAGE",
  ACCOUNT: "ACCOUNT",
} as const

export const ANALYTICS_ACTIONS = {
  CLICK: "CLICK",
  SUBMIT: "SUBMIT",
  SUCCESS: "SUCCESS",
  ERROR: "ERROR",
  OPEN: "OPEN",
  CLOSE: "CLOSE",
  TOGGLE: "TOGGLE",
  COPY: "COPY",
  VIEW: "VIEW",
} as const

export type AnalyticsCategory = (typeof ANALYTICS_CATEGORIES)[keyof typeof ANALYTICS_CATEGORIES]
export type AnalyticsAction = (typeof ANALYTICS_ACTIONS)[keyof typeof ANALYTICS_ACTIONS]

export type AnalyticsUserTier = "FREE" | "PRO" | "ENTERPRISE"

export interface AnalyticsIdentityContext {
  isAuthenticated?: boolean
  userTier?: AnalyticsUserTier
  workspaceId?: string
}

export interface AnalyticsEventInput extends AnalyticsIdentityContext {
  category: AnalyticsCategory
  action: AnalyticsAction
  name: string
  value?: number
  metadata?: Record<string, string | number | boolean | null | undefined>
}

export interface ApiUsageTrackingInput extends AnalyticsIdentityContext {
  routeName: string
  method: string
  status: number
  durationMs: number
  errorName?: string
}

export const ANALYTICS_EVENT_NAMES = {
  PAGE_VIEW_PUBLIC: "PAGE_VIEW_PUBLIC",
  PAGE_VIEW_AUTH: "PAGE_VIEW_AUTH",

  WORKOUT_DATA_LOADED: "WORKOUT_DATA_LOADED",
  WORKOUT_DATA_LOAD_ERROR: "WORKOUT_DATA_LOAD_ERROR",
  WORKOUT_ALREADY_COMPLETED_VIEW: "WORKOUT_ALREADY_COMPLETED_VIEW",
  WORKOUT_SESSION_COMPLETED: "WORKOUT_SESSION_COMPLETED",

  STRETCH_DATA_LOADED: "STRETCH_DATA_LOADED",
  STRETCH_DATA_LOAD_ERROR: "STRETCH_DATA_LOAD_ERROR",
  STRETCH_ALREADY_COMPLETED_VIEW: "STRETCH_ALREADY_COMPLETED_VIEW",
  STRETCH_SESSION_COMPLETED: "STRETCH_SESSION_COMPLETED",

  COOLDOWN_DATA_LOADED: "COOLDOWN_DATA_LOADED",
  COOLDOWN_DATA_LOAD_ERROR: "COOLDOWN_DATA_LOAD_ERROR",
  COOLDOWN_SESSION_COMPLETED: "COOLDOWN_SESSION_COMPLETED",

  SETTINGS_SAVE_SUCCESS: "SETTINGS_SAVE_SUCCESS",

  REPORT_WORKOUT_EMPTY: "REPORT_WORKOUT_EMPTY",
  REPORT_MEASUREMENT_EMPTY: "REPORT_MEASUREMENT_EMPTY",
  REPORT_MEASUREMENT_SAVED: "REPORT_MEASUREMENT_SAVED",

  API_ROUTE_RESULT: "API_ROUTE_RESULT",
} as const
